var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"absolute"}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({
      src: _vm.profile,
      error: _vm.onError(),
      loading: require('@/assets/Rolling-1s-200px_2.svg')
    }),expression:"{\n      src: profile,\n      error: onError(),\n      loading: require('@/assets/Rolling-1s-200px_2.svg')\n    }"}]})])
}
var staticRenderFns = []

export { render, staticRenderFns }